import axiosInstance from "../utils/axios";

export const authService = {
  login: async (body) => {
    const { data } = await axiosInstance.post(`/auth/login`, body);
    return data;
  },
  fetchProfile: async () => {
    const response = await axiosInstance.get("/auth/profile");
    return response.data;
  },
  changePassword: async (data) => {
    const response = await axiosInstance.put(`/auth/profile`, data);
    return response.data;
  },
  me: async () => {
    const { data } = await axiosInstance.get('/auth/me')
    return data
  },
  check: async () => {
    const { data } = await axiosInstance.get('/check')
    return data
  },
  logout: async () => {
    const { data } = await axiosInstance.get('/auth/logout')
    return data
  }
};
